export const LOAD_ADDRESS_BOOK = 'address-book/LOAD_ADDRESS_BOOK';
export const LOAD_ADDRESS_BOOK_SUCCESS =
  'address-book/LOAD_ADDRESS_BOOK_SUCCESS';
export const LOAD_ADDRESS_BOOK_ERROR = 'address-book/LOAD_ADDRESS_BOOK_ERROR';
